module.exports = __webpack_public_path__ + "static/beer-6dad26a39136393767d5153916156fcf.svg";